import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconPlay = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.7336 7L4.90023 3.5V10.5L10.7336 7Z" fill={color} />
        </svg>
    </div>
);

export default IconPlay;
